export type PlanCode = 'xeweul' | 'business' | 'premium';

export const PLAN_ORDER: PlanCode[] = ['xeweul', 'business', 'premium'];

export const PLAN_LABELS: Record<PlanCode, string> = {
  xeweul: 'Pack XEWEUL',
  business: 'Pack BUSINESS',
  premium: 'Pack PREMIUM',
};

export const FEATURE_MINIMUM_PLAN = {
  'dashboard.basic': 'xeweul',
  'dashboard.performance': 'business',
  'dashboard.advanced': 'premium',
  'pos.basic': 'xeweul',
  'pos.multi_cash': 'business',
  'billing.basic': 'xeweul',
  'billing.recurring': 'business',
  'billing.custom_templates': 'business',
  'catalogue.basic': 'xeweul',
  'stock.basic': 'xeweul',
  'stock.inventory': 'business',
  'stock.multi_depot': 'business',
  'stock.transfer': 'business',
  'stock.lot_serial': 'premium',
  'customers.basic': 'xeweul',
  'customers.crm': 'business',
  'customers.loyalty': 'premium',
  'suppliers.basic': 'xeweul',
  'purchases.document_scan': 'xeweul',
  'purchases.orders': 'xeweul',
  'purchases.approval': 'premium',
  'expenses.basic': 'xeweul',
  'accounting.basic': 'business',
  'accounting.advanced': 'premium',
  'accounting.syscohada': 'premium',
  // Conservés pour compatibilité technique avec le module désactivé.
  // Aucune entrée de navigation ne l'expose tant que l'offre RH est suspendue.
  'hr.basic': 'premium',
  'hr.payroll': 'premium',
  'hr.time_tracking': 'premium',
  'reports.basic': 'xeweul',
  'reports.advanced': 'business',
  'reports.bi': 'premium',
  'notifications.basic': 'xeweul',
  'notifications.advanced': 'business',
  'offline.sync': 'xeweul',
  'integrations.api': 'business',
  'audit.full': 'business',
  'workflow.approval': 'premium',
} as const satisfies Record<string, PlanCode>;

export type FeatureCode = keyof typeof FEATURE_MINIMUM_PLAN;

export const FEATURE_LABELS: Record<FeatureCode, string> = {
  'dashboard.basic': 'Tableau de bord',
  'dashboard.performance': 'KPI de performance et rentabilité',
  'dashboard.advanced': 'Prévisions et analyses avancées',
  'pos.basic': 'Caisse POS',
  'pos.multi_cash': 'Multi-caisses',
  'billing.basic': 'Facturation et devis',
  'billing.recurring': 'Facturation récurrente',
  'billing.custom_templates': 'Modèles de documents personnalisés',
  'catalogue.basic': 'Catalogue produits',
  'stock.basic': 'Gestion du stock',
  'stock.inventory': 'Inventaires',
  'stock.multi_depot': 'Gestion multi-dépôts',
  'stock.transfer': 'Transferts entre dépôts',
  'stock.lot_serial': 'Lots, séries et péremptions',
  'customers.basic': 'Gestion des clients',
  'customers.crm': 'CRM et segmentation clients',
  'customers.loyalty': 'Fidélité et portail client',
  'suppliers.basic': 'Gestion des fournisseurs',
  'purchases.document_scan': 'Assistant de réception fournisseur par IA',
  'purchases.orders': 'Commandes et réceptions fournisseurs',
  'purchases.approval': 'Workflows d’approbation des achats',
  'expenses.basic': 'Dépenses, crédits et avances',
  'accounting.basic': 'Comptabilité simple',
  'accounting.advanced': 'Comptabilité analytique et avancée',
  'accounting.syscohada': 'Comptabilité complète SYSCOHADA',
  'hr.basic': 'Ressources humaines',
  'hr.payroll': 'Paie',
  'hr.time_tracking': 'Pointage et temps de travail',
  'reports.basic': 'Rapports essentiels',
  'reports.advanced': 'Rapports avancés',
  'reports.bi': 'Business Intelligence',
  'notifications.basic': 'Alertes essentielles',
  'notifications.advanced': 'Alertes avancées',
  'offline.sync': 'Mode hors ligne',
  'integrations.api': 'Intégrations et API',
  'audit.full': 'Journal d’audit complet',
  'workflow.approval': 'Workflows d’approbation',
};

export interface PlanCapabilities {
  plan: PlanCode;
  planLabel: string;
  features: Record<string, boolean>;
  featureLabels: Record<string, string>;
  limits: Record<string, number | null>;
  usage: Record<string, number>;
}

export function normalizePlan(plan: string | null | undefined): PlanCode {
  if (plan === 'business') return 'business';
  if (plan === 'premium' || plan === 'enterprise') return 'premium';
  return 'xeweul';
}
